// tslint:disable:no-any trailing-comma
import { Observable } from 'rxjs';
import { publishReplay, refCount } from 'rxjs/operators';

export class MemoryMemoizeRepo {
  static cachedMethods: Map<
    string,
    {
      args: any[]
      returnVal: any
    }
  > = new Map<string, { args: any[]; returnVal: any }>();
}

export function cacheMethod(): MethodDecorator {
  return function(target: Function, propertyKey: string, descriptor: PropertyDescriptor) {
    const original = descriptor.value;

    descriptor.value = function(...args: any[]) {
      const cacheKey = propertyKey + JSON.stringify(args);
      if (MemoryMemoizeRepo.cachedMethods.has(cacheKey)) {
        const cachedMemo = MemoryMemoizeRepo.cachedMethods.get(cacheKey);
        const instanceOfOb = cachedMemo.returnVal instanceof Observable;
        if (instanceOfOb) {
          const returnValue = cachedMemo.returnVal as Observable<any>;
          return returnValue.pipe(
            publishReplay(1),
            refCount(),
          );
        }

        return cachedMemo.returnVal;
      }

      let result = original.apply(this, args);

      if (result instanceof Observable) {
        const returnValue = result as Observable<any>;
        result = returnValue.pipe(
          publishReplay(1),
          refCount(),
        );
      }

      MemoryMemoizeRepo.cachedMethods.set(propertyKey + JSON.stringify(args), {
        args: args,
        returnVal: result,
      });

      return result;
    };

    return descriptor;
  };
}
